/* POP-UP DE CAPTACIÓN AL CLUB
 *
 * Tres mensajes × dos formatos = seis piezas, que rotan. La regla que pidió
 * Raúl: cada vez que el cliente cambia de página (o vuelve a entrar) debe ver
 * una DISTINTA. Por eso no se sortea a ciegas — se lleva memoria de las últimas
 * vistas y se sortea entre las que no ha visto todavía; cuando las ha visto
 * todas, se vacía la memoria y vuelve a empezar. Con azar puro le saldría la
 * misma dos y tres veces seguidas y parecería que está roto.
 *
 * No se enseña a quien ya está registrado ni a quien ya lo cerró hoy.
 */
(function () {
  /* Traduce al idioma del mercado (friky-i18n.js). Si el diccionario aún no ha
     cargado, devuelve el texto tal cual: nunca rompe la interfaz. */
  function FTH(h) { return window.FTH ? window.FTH(h) : h; }
  function FT(t) { return window.FT ? window.FT(t) : t; }

  'use strict';
  var K_VISTAS = 'fpc_vistas', K_CERRADO = 'fpc_cerrado', K_REG = 'fpc_registrado';
  var CFG = window.FRIKY_POPUP_CLUB || {};
  var HORAS_DESCANSO = CFG.horasDescanso || 24;   // tras cerrarlo, no molestar
  var SEG_ESPERA = CFG.segundosEspera != null ? CFG.segundosEspera : 6;

  // Modo previsualización: ?fpc=1 lo fuerza aunque estés logueado o lo hayas
  // cerrado. Sirve para verlo sin cerrar sesión. ?fpc=reset borra la memoria.
  var qs = new URLSearchParams(location.search);
  var forzar = qs.get('fpc');
  if (forzar === 'reset') {
    try { localStorage.removeItem(K_VISTAS); localStorage.removeItem(K_CERRADO); localStorage.removeItem(K_REG); } catch (e) {}
  }

  if (!forzar) {
    // ¿Ya es cliente? No se le pide que se registre.
    //
    // OJO: aquí NO se guarda nada en localStorage. La primera versión marcaba
    // «registrado» de por vida, así que si el cliente cerraba sesión —o era un
    // ordenador compartido— no volvía a ver el pop-up jamás. La comprobación de
    // sesión ya es instantánea; no hace falta recordarla.
    if ((window.FRIKY_B2B && window.FRIKY_B2B.id) || window.FRIKY_CUSTOMER_ID ||
        document.body.classList.contains('customer-logged-in')) return;

    // ¿Lo cerró hace poco?
    try {
      var c = Number(localStorage.getItem(K_CERRADO) || 0);
      if (c && (Date.now() - c) < HORAS_DESCANSO * 3600e3) return;
    } catch (e) {}
  }

  // ── Los tres mensajes ──────────────────────────────────────
  // El texto de los puntos sale de la configuración real del club: si un día se
  // cambian los 100 puntos de alta, el pop-up dice la verdad sin tocar código.
  var PUNTOS = CFG.puntosAlta || 100;
  var EUROS = CFG.eurosAlta || (PUNTOS / 100 * 5);
  var eur = function (n) { return (Math.round(n * 100) / 100).toLocaleString('es-ES') + ' €'; };

  var MENSAJES = CFG.mensajes || [
    { id: 'figura', icono: '🎁', tag: 'Club Frikytopia',
      titulo: 'Hazte del club y llévate una figura gratis',
      sub: 'Solo por registrarte entras en el sorteo mensual de una figura de coleccionista. Y empiezas a sumar puntos desde tu primera compra.',
      cta: 'Quiero mi figura' },
    { id: 'puntos', icono: '🏆', tag: 'Regalo de bienvenida',
      titulo: PUNTOS + ' puntos de regalo al registrarte',
      sub: 'Son ' + eur(EUROS) + ' para tu próxima compra. Los canjeas cuando quieras y por el importe que quieras, sin mínimos.',
      cta: 'Quiero mis ' + PUNTOS + ' puntos' },
    { id: 'envio', icono: '🚚', tag: 'Solo para socios',
      titulo: 'Envío gratis en tu primer pedido',
      sub: 'Date de alta y te lo llevas sin gastos de envío. Además entras en el club y empiezas a acumular puntos.',
      cta: 'Quiero el envío gratis' },
  ];
  var FORMATOS = ['modal', 'side'];

  // Todas las combinaciones posibles, en un identificador estable.
  var PIEZAS = [];
  MENSAJES.forEach(function (m) { FORMATOS.forEach(function (f) { PIEZAS.push(m.id + '|' + f); }); });

  // Elige una que NO haya visto. Cuando las ha visto todas, se reinicia.
  function elegir() {
    var vistas = [];
    try { vistas = JSON.parse(localStorage.getItem(K_VISTAS) || '[]'); } catch (e) {}
    var quedan = PIEZAS.filter(function (p) { return vistas.indexOf(p) < 0; });
    if (!quedan.length) { quedan = PIEZAS.slice(); vistas = []; }
    var elegida = quedan[Math.floor(Math.random() * quedan.length)];
    vistas.push(elegida);
    try { localStorage.setItem(K_VISTAS, JSON.stringify(vistas.slice(-PIEZAS.length))); } catch (e) {}
    return elegida;
  }

  function cerrar(el, back) {
    el.classList.remove('on'); if (back) back.classList.remove('on');
    try { localStorage.setItem(K_CERRADO, String(Date.now())); } catch (e) {}
    setTimeout(function () { el.remove(); if (back) back.remove(); }, 320);
  }

  function pintar() {
    var partes = elegir().split('|');
    var msg = MENSAJES.filter(function (m) { return m.id === partes[0]; })[0] || MENSAJES[0];
    var formato = partes[1];
    // Marca el enlace con la creatividad y el formato que han traído el alta.
  // Sin esto todas las altas salen por '/account/register' y no hay forma de
  // saber qué pieza funciona. Lo recoge friky-track.js al llegar a la web.
  function conOrigen(url, id, formato) {
    try {
      var u = new URL(url, location.origin);
      u.searchParams.set('fclub', 'popup-' + id + '-' + (formato === 'modal' ? 'modal' : 'lateral'));
      return u.pathname + u.search + u.hash;
    } catch (e) { return url; }
  }
  var destino = CFG.urlRegistro || '/account/register';

    var back = null;
    if (formato === 'modal') {
      back = document.createElement('div');
      back.className = 'fpc-back';
      document.body.appendChild(back);
    }

    var el = document.createElement('div');
    el.className = formato === 'modal' ? 'fpc-modal' : 'fpc-side';
    el.setAttribute('role', 'dialog');
    el.setAttribute('aria-label', msg.titulo);

    var hero = '<div class="fpc-hero"><span>' + msg.icono + '</span></div>';
    var cuerpo =
      '<div class="fpc-body">' +
        '<span class="fpc-tag">' + msg.tag + '</span>' +
        '<h3 class="fpc-tit">' + msg.titulo + '</h3>' +
        '<p class="fpc-sub">' + msg.sub + '</p>' +
        '<a class="fpc-cta" href="' + conOrigen(destino, msg.id, formato) + '">' + msg.cta + '</a>' +
        '<button class="fpc-no" type="button">Ahora no</button>' +
      '</div>';

    el.innerHTML = FTH('<button class="fpc-x" type="button" aria-label="Cerrar">×</button>' +
      (formato === 'modal' ? hero + cuerpo : '<div class="fpc-row">' + hero + cuerpo + '</div>'));
    document.body.appendChild(el);

    requestAnimationFrame(function () {
      el.classList.add('on'); if (back) back.classList.add('on');
    });

    el.querySelector('.fpc-x').addEventListener('click', function () { cerrar(el, back); });
    el.querySelector('.fpc-no').addEventListener('click', function () { cerrar(el, back); });
    if (back) back.addEventListener('click', function () { cerrar(el, back); });
    document.addEventListener('keydown', function esc(ev) {
      if (ev.key === 'Escape') { cerrar(el, back); document.removeEventListener('keydown', esc); }
    });
    // Si pulsa el botón, damos por hecho que se registra: no volvemos a insistir.
    el.querySelector('.fpc-cta').addEventListener('click', function () {
      try { localStorage.setItem(K_CERRADO, String(Date.now())); } catch (e) {}
    });
  }

  // No aparece en el propio registro, ni en la cuenta, ni durante el pago.
  var p = location.pathname;
  if (!forzar && /\/account|\/checkout|\/cart\/?$/.test(p)) return;

  setTimeout(pintar, forzar ? 300 : SEG_ESPERA * 1000);
})();
